import { render } from "./item-form.vue?vue&type=template&id=13f1c52d"
import script from "./item-form.vue?vue&type=script&lang=js"
export * from "./item-form.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__